// store/tickets.js
//
// Vuex store for the ticket log and ticket creation. Mirrors the pattern
// used by store/users.js and store/devices.js — the api service handles
// auth header and base URL, so action bodies stay thin.

import apiClient from '../services/api'

const state = {
  tickets:        [],
  loading:        false,
  creating:       false,
  lastCreateError: null,
}

const mutations = {
  SET_TICKETS(state, tickets)   { state.tickets         = tickets },
  ADD_TICKET(state, ticket)     { state.tickets.unshift(ticket)  },
  SET_LOADING(state, val)       { state.loading         = val    },
  SET_CREATING(state, val)      { state.creating        = val    },
  SET_CREATE_ERROR(state, err)  { state.lastCreateError = err    },
}

const actions = {
  async fetchTickets({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await apiClient.get('/tickets')
      commit('SET_TICKETS', data)
      return data
    } catch (err) {
      console.error('Error fetching tickets:', err)
      throw err
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Create a ticket and refresh the log so the new row appears in the
  // Settings → Tickets tab. The CRM call happens server-side; the
  // response includes crmTaskId on success and a details string on
  // failure (which surfaces in lastCreateError for the dialog to show).
  async createTicket({ commit, dispatch }, ticketData) {
    commit('SET_CREATING', true)
    commit('SET_CREATE_ERROR', null)
    try {
      const { data } = await apiClient.post('/tickets', ticketData)
      // Refresh the log rather than constructing a row client-side —
      // the server fills in ticketId, userName, createdAt, crmTaskId,
      // and the truth on status (sent/failed), which is more reliable
      // than mirroring that logic here.
      await dispatch('fetchTickets')
      return data
    } catch (err) {
      const msg = err.response?.data?.details
                || err.response?.data?.error
                || err.message
      commit('SET_CREATE_ERROR', msg)
      console.error('Error creating ticket:', err)
      throw err
    } finally {
      commit('SET_CREATING', false)
    }
  },
}

const getters = {
  tickets:         (s) => s.tickets,
  ticketCount:     (s) => s.tickets.length,
  loading:         (s) => s.loading,
  creating:        (s) => s.creating,
  lastCreateError: (s) => s.lastCreateError,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}